<template>
  <div>
      <h2>Registrar Entrada Personas</h2>      
        <form class="text-left">          
            <div class="form-group">
                <label class='etiquetaLabel' for="fecha">Fecha</label><br/>
                <input type="date" class="etiqueta" v-model='fechaing' >  
            </div>
            <div class="form-group">
                <label class='etiquetaLabel' for="rut">Rut</label><br/>
                <input type="text" class="etiqueta" v-model='rut' readonly maxlength="9" minlength="9" size="9" >  
            </div>

            <div class="form-group">
                <label class='etiquetaLabel' for="tipo">Tipo</label><br/>
                <input type="text" class="etiqueta" v-model='residente' readonly >  
            </div>
            
            <div class="form-group">
                <label class='etiquetaLabel' for="numerodepartamento">Depto</label><br/>
                <input id='numerodepartamento' type="number" class="etiqueta" v-model.number="numerodepartamento" min='1' max="2299"  size="4" maxlength="4" >           
            </div>
            <div class="form-group">
                <label class='etiquetaLabel' for="nombre">Nombre</label>
                <input id='nombre' type="text" class="etiqueta" v-model="nombre" size="15" maxlength="20" readonly>           
            </div>
            <div class="my-5">
                    <button type="button" class="btn btn-primary btn-block my-3" @click.prevent="savePersona">Save </button>
                    <button type="button" class="btn btn-secondary btn-block my-3" @click.prevent="volver"  >Close</button>
            </div>

        </form>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    name:'PersonaEntrada',
    components:{

    },
    data(){
      return{
        mipersona:{},
        fecha: new Date(),
        fechaing:'',
        horaing:'',
        nombre:'',
        numerodepartamento:'',
        rut:'',
        residente:''

      }
    },
    mounted(){
       this.rut=this.$route.params.id;
       this.mipersona = this.$store.getters.enviardatapersonas.filter(datos => {
                return datos.rut.includes(this.$route.params.id.toUpperCase())
            });
       this.fechaing= this.fecha.getDate() + '/' + (this.fecha.getMonth() + 1) + '/' + this.fecha.getFullYear();
       this.horaing= this.fecha.getHours() + ':' + this.fecha.getMinutes();
       this.nombre = this.mipersona[0].nombre;
       this.residente = this.mipersona[0].residente;
       this.numerodepartamento = this.mipersona[0].departamento;
    },
    methods:{
       volver(){
            this.$router.push('/personas');
        },
        savePersona(){
            console.log("entramos a grabar ")
            if(this.numerodepartamento && this.residente && this.nombre){
                let auxiliar={
                    fechaing:this.fechaing,
                    horaing:this.horaing,
                    rut:this.rut.toUpperCase(),
                    residente:this.residente.toUpperCase(),
                    numerodepartamento:this.numerodepartamento,
                    nombre:this.nombre.toUpperCase(),
                }
                this.$store.dispatch('savePersona',auxiliar);                                 
                this.$router.push('/personas');
            }else{
                Swal.fire("Escriba datos")                 
            }
            this.residente='Visitante';
            this.numerodepartamento=9999;
            this.nombre='';

        }
    }
    
}
</script>

<style>

</style>